import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container py-4" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 col-lg-3 mb-3" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-body p-2" }
const _hoisted_6 = { class: "list-group list-group-flush small" }
const _hoisted_7 = { class: "col-12 col-lg-9" }
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = {
  key: 0,
  class: "text-secondary"
}
const _hoisted_11 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_12 = ["innerHTML"]

import { ref, computed, watch, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { marked } from 'marked';

type DocIndexItem = { slug: string; file: string; title: string };


export default /*@__PURE__*/_defineComponent({
  __name: 'Docs',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const items = ref<DocIndexItem[]>([]);
const search = ref('');
const currentSlug = ref<string>('');
const html = ref<string>('');
const loading = ref<boolean>(false);
const error = ref<string>('');

const filteredItems = computed(() => {
  const q = search.value.trim().toLowerCase();
  if (!q) return items.value;
  return items.value.filter((i) => i.title.toLowerCase().includes(q) || i.slug.includes(q));
});

async function fetchIndex() {
  try {
    const res = await fetch('/docs/index.json', { cache: 'no-cache' });
    if (!res.ok) throw new Error(`Failed to load docs index (${res.status})`);
    items.value = await res.json();
  } catch (e: any) {
    error.value = e?.message || 'Unable to load docs index';
  }
}

async function loadDoc(slug?: string) {
  if (!items.value.length) return;
  loading.value = true;
  error.value = '';
  try {
    const targetSlug = slug || (items.value[0] && items.value[0].slug);
    const item = items.value.find((i) => i.slug === targetSlug) || items.value[0];
    if (!item) throw new Error('No docs available');
    currentSlug.value = item.slug;
    const res = await fetch(`/docs/${item.file}`, { cache: 'no-cache' });
    if (!res.ok) throw new Error(`Failed to load ${item.file} (${res.status})`);
    const md = await res.text();
    const rawHtml = marked.parse(md);
    // Rewrite relative markdown links (e.g., BRANDING.md#section) to our /docs/:slug routes
    const toSlug = (s: string) => s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    html.value = rawHtml.replace(/href=\"([^:\"]+?)\.md(#[^\"]*)?\"/g, (_m, base, hash) => {
      return `href=\"/docs/${toSlug(base)}${hash || ''}\"`;
    });
  } catch (e: any) {
    error.value = e?.message || 'Unable to load document';
  } finally {
    loading.value = false;
  }
}

onMounted(async () => {
  await fetchIndex();
  const initialSlug = (route.params.slug as string) || '';
  await loadDoc(initialSlug);
});

watch(
  () => route.params.slug,
  async (slug) => {
    await loadDoc((slug as string) || '');
  }
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
              type: "search",
              class: "form-control form-control-sm mb-2",
              placeholder: "Search docs...",
              "aria-label": "Search docs"
            }, null, 512), [
              [_vModelText, search.value]
            ]),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredItems.value, (item) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  key: item.slug,
                  class: _normalizeClass(["list-group-item list-group-item-action", { active: currentSlug.value === item.slug }]),
                  to: { path: '/docs/' + item.slug }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.title), 1)
                  ]),
                  _: 2
                }, 1032, ["class", "to"]))
              }), 128))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Loading…"))
              : (error.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(error.value), 1))
                : (_openBlock(), _createElementBlock("article", {
                    key: 2,
                    class: "docs-content",
                    innerHTML: html.value
                  }, null, 8, _hoisted_12))
          ])
        ])
      ])
    ])
  ]))
}
}

})